import React from 'react'
import './Input.scss'

export const Input = props => {


    return (
        <div className='input'>
            <input
                placeholder={props.name}
                onChange={props.onChange}
                type = {props.type}
                className={props.class}
            />
        </div>
    )
}

